import React from "react";
import { Outlet } from "react-router-dom";

export const Policies: React.FC<object> = () => {
  return <Outlet />;
};
